import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { footerScript } from 'src/app/@shared/javascript/script';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from 'src/app/auth/login/login.component';
declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent extends BaseClass<any> implements OnInit {

  constructor(
    public service: WebserviceService,
    public router: Router,
    public _common: CommonService
  ) {
    super(document);
  }

  ngOnInit(): void {
    footerScript()
    // $("#menu-toggle").click(function(e:any) {
    //   e.preventDefault();
    //   $("body").toggleClass("mobileMegaMenu");
    // });

  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  redirect() {
    this.router.navigate(['/exchange_sports/4'])
  }

  toggleMenu() {
    $("body").toggleClass("mobileMegaMenu");
  }

  confirmBox() {
    if (this.isLogin()) {
      this.router.navigate([`/reports/my-bets`]);
    } else {
      this._common.goToLogin();
    }
  }

  chatShow() {
    if(this.router.url.includes('/home') || this.router.url.includes('/dashboard') || this.router.url.includes('/exchange_sports')) {
      return true;
    }
    return false;
  }

}
